<template>
  <v-row dense>
    <v-col>
      <v-row>
        <v-col>
          <DebouncedSearchField v-model="searchQuery" />
        </v-col>

        <v-spacer />

        <v-col cols="auto">
          <v-dialog v-model="dialog" max-width="500px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="light-blue"
                dark
                v-bind="attrs"
                v-on="on"
                @click:outside="close"
              >
                Novo medicamento
              </v-btn>
            </template>

            <v-card>
              <v-card-title>
                <span class="headline">Novo medicamento</span>
              </v-card-title>

              <v-card-text>
                <v-container fluid>
                  <v-row dense>
                    <v-col cols="12">
                      <v-text-field
                        outlined
                        dense
                        v-model="medicine.name"
                        label="Nome"
                        :hide-details="!errors.medicine"
                        :error-messages="errors.medicine"
                      />
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">
                  Cancelar
                </v-btn>

                <v-btn color="blue darken-1" text @click="save"> Salvar </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>

      <template v-if="hasMedicines">
        <v-pagination
          v-model="currentPage"
          :length="totalPages"
          :total-visible="10"
          class="mb-2"
        />

        <p v-if="searchQuery" class="text-center">
          Foram encontrados <strong>{{ totalCount }} medicamentos</strong> que
          correspondem à busca.
        </p>
        <p v-else class="text-center">
          Foram encontrados <strong>{{ totalCount }} medicamentos</strong>.
        </p>
      </template>

      <SpinnerRow v-if="isLoading" text="Carregando medicamentos..." />
      <p v-else-if="!hasMedicines" class="mt-2 text-center">
        Não foi encontrado nenhum medicamento que corresponda à busca.
      </p>
      <template v-else>
        <v-row dense v-for="medicine in medicines" :key="medicine.id">
          <v-col>
            <MedicineListItem :medicine="medicine" :refreshList="refreshList" />
          </v-col>
        </v-row>

        <v-pagination
          v-model="currentPage"
          :length="totalPages"
          :total-visible="10"
          class="mt-2"
        />
      </template>
    </v-col>
  </v-row>
</template>

<script>
import SpinnerRow from "@/components/ui/load_status/spinner-row.vue";
import DebouncedSearchField from "@/components/ui/form/debounced_search_field.vue";
import MedicineListItem from "@/components/config/medicine/medicine/item/index.vue";
import GET_MEDICINES from "@/components/config/medicine/medicine/getMedicines.gql";

export default {
  name: "MedicineList",
  components: {
    MedicineListItem,
    SpinnerRow,
    DebouncedSearchField,
  },
  data() {
    return {
      errors: {},
      dialog: null,
      medicine: {},
      searchQuery: null,
      currentPage: 1,
      totalPages: 1,
      totalCount: 0,
    };
  },
  apollo: {
    medicines: {
      query: GET_MEDICINES,
      update({ medicines }) {
        this.currentPage = medicines.metadata.currentPage;
        this.totalPages = medicines.metadata.totalPages;
        this.totalCount = medicines.metadata.totalCount;

        return medicines.collection;
      },
      variables() {
        return {
          page: this.currentPage,
          limit: 25,
          searchQuery: this.searchQuery || null,
        };
      },
    },
  },
  computed: {
    isLoading() {
      return this.$apollo.queries.medicines.loading;
    },
    hasMedicines() {
      return this.medicines?.length > 0;
    },
  },
  watch: {
    searchQuery() {
      this.currentPage = 1;
    },
    currentPage() {
      this.refreshList();
    },
  },
  methods: {
    close() {
      this.dialog = false;
      this.medicine = {};
    },
    save() {
      if (!this.validate()) return;

      this.apolloMutate({
        mutation: require("@/graphql/medicine/save_medicine.gql"),
        variables: {
          medicineId: "",
          name: this.medicine.name,
        },
      }).then(() => {
        this.refreshList();

        this.$store.dispatch("createNotification", {
          message: "Cadastro salvo com sucesso.",
          type: "success",
        });
      });

      this.close();
    },
    refreshList() {
      this.$apollo.queries.medicines.refetch();
    },
    validate() {
      const errorMsg = "Esse campo deve ser preenchido.";
      this.errors = {};

      let name = this.medicine.name;
      if (this.lodash.isEmpty(name?.trim())) {
        this.errors.medicine = errorMsg;
      }

      if (Object.keys(this.errors).length === 0) {
        return true;
      }

      return false;
    },
  },
};
</script>

<style lang="scss" scoped></style>
